"use client";

import React from "react";
import SectionLayout from "../ui/SectionLayout";
import { SectionProps } from "./model";
import { getDefaultCmsSection } from "@/utils/helper";

const CookiePolicySection: React.FC<
  SectionProps<{ contentTextColor: string, headerTextColor: string }>
> = ({ cmsSection }) => {
  return (
    <SectionLayout
      cmsSection={getDefaultCmsSection(cmsSection, {
        width: "xl",
      })}
    >
      <div className="flex h-full flex-col w-full items-center justify-center homepage-p-md homepage-gap-lg">
        <div className="flex h-full w-full justify-start">
          <div className="styled-description homepage-text-sm homepage-p-none">
            <div>
              <p>
                Når du besøger denne hjemmeside, indsamler vi automatisk visse oplysninger om din enhed, browser og din interaktion med siden. Denne cookiepolitik forklarer, hvilke cookies vi anvender, hvordan vi benytter dem, og hvilke muligheder du har for at styre cookie-indstillingerne.
              </p>
              <p>
                Ved at fortsætte med at benytte hjemmesiden accepterer du brugen af cookies i overensstemmelse med denne politik.
              </p>
              <div className="homepage-text-md">
                Hvad er en cookie?
              </div>
              <p>
                En cookie er en lille tekstfil, der lagres på din enhed og hjælper os med at genkende din browser ved gentagne besøg. Cookies er uskadelige og kan ikke indeholde personlige data eller virus.
              </p>
              <div className="homepage-text-md">
                Hvordan bruger vi cookies?
              </div>
              <p>Vi anvender cookies til at:</p>
              <ul>
                <li>Forbedre din brugeroplevelse ved at huske dine præferencer</li>
                <li>Analysere trafik og brugsmønstre for løbende at optimere hjemmesiden</li>
                <li>Muliggøre vigtige funktioner som login og brugeradministration</li>
              </ul>
              <div className="homepage-text-md">
                Varigheden af cookies
              </div>
              <p>
                Nogle cookies slettes automatisk, når du lukker din browser, mens andre forbliver gemt i en bestemt periode, der kan variere fra få timer til flere måneder.
              </p>
              <div className="homepage-text-md">
                Styring af cookies
              </div>
              <p>
                Du kan når som helst ændre dine cookie-indstillinger via din browsers indstillinger. Dette giver dig mulighed for at blokere eller slette cookies. For yderligere vejledning, se din browsers hjælpefunktion eller besøg:
                <a href="http://minecookies.org/cookiehandtering" target="_blank">http://minecookies.org/cookiehandtering</a>.
              </p>
              <div className="homepage-text-md">
                Cookies fra tredjepart
              </div>
              <p>
                Vi kan anvende cookies fra tredjepartsleverandører til blandt andet analyse og annoncering. Disse cookies er underlagt tredjepartens egne politikker, og du kan finde yderligere information samt fravalgsmuligheder på deres hjemmesider.
              </p>
              <div className="homepage-text-md">
                Google Analytics
              </div>
              <p>
                Vi bruger Google Analytics til at måle trafik og brugeradfærd på hjemmesiden. Du kan fravælge Google Analytics ved at besøge:
                <a href="https://tools.google.com/dlpage/gaoptout" target="_blank">https://tools.google.com/dlpage/gaoptout</a>.
              </p>
            </div>
          </div>
        </div>
      </div>

    </SectionLayout>
  );
};

export default CookiePolicySection;
